// [CP01][DM01][CS02][NS01] Extrahiere eine flache Gemeinde-Liste aus gemeinde-data.json für die QuickSearch-Komponente
import gemeindeDataRaw from '../../public/data/gemeinde-data.json';

interface Gemeinde {
  nr: string;
  name: string;
  plz: string;
}

// Erzeuge eine Liste aller Gemeinden mit der ersten PLZ
const gemeindeListe: Gemeinde[] = [];

if (gemeindeDataRaw && gemeindeDataRaw.gemeinden) {
  const gemeindeMap = new Map<string, Gemeinde>();
  
  gemeindeDataRaw.gemeinden.forEach(gemeinde => {
    if (!gemeindeMap.has(gemeinde.gemeindeNummer) && gemeinde.plzList && gemeinde.plzList.length > 0) {
      gemeindeMap.set(gemeinde.gemeindeNummer, {
        nr: gemeinde.gemeindeNummer,
        name: gemeinde.name,
        plz: gemeinde.plzList[0] // Nimm nur die erste PLZ
      });
    }
  });
  
  // Konvertiere die Map zurück in ein Array
  gemeindeListe.push(...gemeindeMap.values());
  
  // Sortiere die Liste alphabetisch nach Gemeindename
  gemeindeListe.sort((a, b) => a.name.localeCompare(b.name, 'de'));
}

export type { Gemeinde };
export { gemeindeListe };
